import { render } from "./EndGameBuddy0.vue?vue&type=template&id=3336d369&scoped=true"
import script from "./EndGameBuddy0.vue?vue&type=script&lang=js"
export * from "./EndGameBuddy0.vue?vue&type=script&lang=js"

import "./EndGameBuddy0.vue?vue&type=style&index=0&id=3336d369&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3336d369"]])

export default __exports__